import { clamp } from "../util/math.ts";

export const toDesc = (impact: number): string => {
  const clampedImpact = clamp(impact, 0, 1);
  if (clampedImpact <= 0.25) {
    return "SM";
  } else if (clampedImpact <= 0.5) {
    return "MD";
  } else if (clampedImpact <= 0.75) {
    return "LG";
  } else {
    return "XL";
  }
};
